import { BaseComponent, Component, Prop, Ref, SimpleEvent, Watch } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

/**
 * Group Element With Label
 */
@Component
export class GroupElementWithLabel extends ThemeComponent {

}
